import { Box, Drawer } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { CheckCircle } from "@mui/icons-material";

import { requestInProgress, requestProgressMsg, backToHome } from "./messages";
import Text from "./text/Text";
import Button from "./button/Button";
import { useNavigate } from "react-router-dom";

function StatementSentDrawer({ open, handleDrawerClose }) {
  const navigate = useNavigate();
  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={handleDrawerClose}
      className="filter-drawer-wrapper request-sent-drawer"
    >
      <Box className="drawer-header">
        <ArrowBackIcon
          sx={{ cursor: "pointer" }}
          onClick={() => handleDrawerClose()}
        ></ArrowBackIcon>
      </Box>
      <Box className="drawer-body">
        <CheckCircle className="tick-icon mb-16" />
        <Text size={20} font="semibold">
          {requestInProgress}
        </Text>
        <Text
          size={14}
          className="grey-text"
          font="regular"
          sx={{ margin: "10px 0" }}
        >
          {requestProgressMsg}
        </Text>
      </Box>
      <Box className="drawer-footer">
        <Button
          variant="default"
          className="submit-btn"
          label={backToHome}
          onClick={() => {
            navigate("/dashboard");
          }}
        />
      </Box>
    </Drawer>
  );
}
export default StatementSentDrawer;
